import { render, staticRenderFns } from "./BankDetailsDynamicForm.vue?vue&type=template&id=15662f78&scoped=true&slot=content"
import script from "./BankDetailsDynamicForm.vue?vue&type=script&lang=js"
export * from "./BankDetailsDynamicForm.vue?vue&type=script&lang=js"
import style0 from "./BankDetailsDynamicForm.vue?vue&type=style&index=0&id=15662f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15662f78",
  null
  
)

export default component.exports